import { createReducer, on } from '@ngrx/store';
import { SystemIntegrationLogin } from 'brain-data/model/system-integration-login.model';
import { SystemIntegrationContact } from 'brain-data/model/system-integration-contact.model';
import {
  createSystemIntegrationContact,
  createSystemIntegrationContactError,
  createSystemIntegrationContactSuccess,
  createSystemIntegrationLogin,
  createSystemIntegrationLoginError,
  createSystemIntegrationLoginSuccess,
  deleteSystemIntegrationContact,
  deleteSystemIntegrationContactError,
  deleteSystemIntegrationContactSuccess,
  deleteSystemIntegrationLogin,
  deleteSystemIntegrationLoginError,
  deleteSystemIntegrationLoginSuccess,
  loadSystemIntegrationContacts,
  loadSystemIntegrationContactsError,
  loadSystemIntegrationContactsSuccess,
  loadSystemIntegrationLoginPassword,
  loadSystemIntegrationLoginPasswordError,
  loadSystemIntegrationLoginPasswordSuccess,
  loadSystemIntegrationLogins,
  loadSystemIntegrationLoginsError,
  loadSystemIntegrationLoginsSuccess,
  updateSystemIntegrationContact,
  updateSystemIntegrationContactError,
  updateSystemIntegrationContactSuccess,
  updateSystemIntegrationLogin,
  updateSystemIntegrationLoginError,
  updateSystemIntegrationLoginSuccess,
} from '../actions/system-integration.actions';

export default interface SystemIntegrationState {
  logins: SystemIntegrationLogin[];
  loading: boolean;
  error: any;
  mutationLoading: boolean;
  mutationError: any;
  passwordByLoginId: Record<number, string>;
  passwordLoading: boolean;
  passwordError: any;
  contactsByLoginId: Record<number, SystemIntegrationContact[]>;
  contactsLoading: boolean;
  contactsError: any;
  contactMutationLoading: boolean;
  contactMutationError: any;
}

export const initialSystemIntegrationState: SystemIntegrationState = {
  logins: [],
  loading: false,
  error: null,
  mutationLoading: false,
  mutationError: null,
  passwordByLoginId: {},
  passwordLoading: false,
  passwordError: null,
  contactsByLoginId: {},
  contactsLoading: false,
  contactsError: null,
  contactMutationLoading: false,
  contactMutationError: null,
};

export const systemIntegrationReducer = createReducer(
  initialSystemIntegrationState,
  on(loadSystemIntegrationLogins, (state): SystemIntegrationState => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadSystemIntegrationLoginsSuccess, (state, { logins }): SystemIntegrationState => ({
    ...state,
    logins,
    loading: false,
    error: null,
  })),
  on(loadSystemIntegrationLoginsError, (state, { error }): SystemIntegrationState => ({
    ...state,
    loading: false,
    error,
  })),

  on(createSystemIntegrationLogin, updateSystemIntegrationLogin, deleteSystemIntegrationLogin, (state): SystemIntegrationState => ({
    ...state,
    mutationLoading: true,
    mutationError: null,
  })),
  on(
    createSystemIntegrationLoginSuccess,
    updateSystemIntegrationLoginSuccess,
    deleteSystemIntegrationLoginSuccess,
    (state): SystemIntegrationState => ({
      ...state,
      mutationLoading: false,
      mutationError: null,
    }),
  ),
  on(
    createSystemIntegrationLoginError,
    updateSystemIntegrationLoginError,
    deleteSystemIntegrationLoginError,
    (state, { error }): SystemIntegrationState => ({
      ...state,
      mutationLoading: false,
      mutationError: error,
    }),
  ),

  on(loadSystemIntegrationLoginPassword, (state): SystemIntegrationState => ({
    ...state,
    passwordLoading: true,
    passwordError: null,
  })),
  on(loadSystemIntegrationLoginPasswordSuccess, (state, { id, password }): SystemIntegrationState => ({
    ...state,
    passwordByLoginId: { ...state.passwordByLoginId, [id]: password.password },
    passwordLoading: false,
    passwordError: null,
  })),
  on(loadSystemIntegrationLoginPasswordError, (state, { error }): SystemIntegrationState => ({
    ...state,
    passwordLoading: false,
    passwordError: error,
  })),

  on(loadSystemIntegrationContacts, (state): SystemIntegrationState => ({
    ...state,
    contactsLoading: true,
    contactsError: null,
  })),
  on(loadSystemIntegrationContactsSuccess, (state, { loginId, contacts }): SystemIntegrationState => ({
    ...state,
    contactsByLoginId: { ...state.contactsByLoginId, [loginId]: contacts },
    contactsLoading: false,
    contactsError: null,
  })),
  on(loadSystemIntegrationContactsError, (state, { error }): SystemIntegrationState => ({
    ...state,
    contactsLoading: false,
    contactsError: error,
  })),

  on(createSystemIntegrationContact, updateSystemIntegrationContact, deleteSystemIntegrationContact, (state): SystemIntegrationState => ({
    ...state,
    contactMutationLoading: true,
    contactMutationError: null,
  })),
  on(
    createSystemIntegrationContactSuccess,
    updateSystemIntegrationContactSuccess,
    deleteSystemIntegrationContactSuccess,
    (state): SystemIntegrationState => ({
      ...state,
      contactMutationLoading: false,
      contactMutationError: null,
    }),
  ),
  on(
    createSystemIntegrationContactError,
    updateSystemIntegrationContactError,
    deleteSystemIntegrationContactError,
    (state, { error }): SystemIntegrationState => ({
      ...state,
      contactMutationLoading: false,
      contactMutationError: error,
    }),
  ),
);
